const membershipStatus = {
  vehicle: 'Vehicle',
  personal: 'Personal', // token is expired and user will need to login again
  // token is expired but new token can be requested without prompting to re-login
  hybrid: 'Hybrid',
};

export default membershipStatus;
